import { Component, Input } from '@angular/core';

@Component({
  selector: 'g99-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false,
})
export class CardComponent {
  @Input() public variant: 'border' | 'borderless' = 'borderless';
  @Input() public backgroundColor = '#ffffff'; // Default background color
  @Input() public borderColor = '#e0e0e0'; // Default border color
  @Input() public styleProp: { [key: string]: string | number } = {};
  @Input() public pt = '20px'; // padding-top
  @Input() public pr = '20px'; // padding-right
  @Input() public pb = '20px'; // padding-bottom
  @Input() public pl = '20px'; // padding-left

  @Input() public topLeftRadius = 10;
  @Input() public topRightRadius = 10;
  @Input() public bottomLeftRadius = 10;
  @Input() public bottomRightRadius = 10;
  @Input() public minHeight = 10;
  @Input() public minWidth = 10;

  @Input() public hideBottomBorder = false; // Toggle to hide or show the bottom border
  @Input() public hideTopBorder = false;

  public mergedStyles(): { [key: string]: string | number } {
    let borderBottomColor = 'transparent'; // Default value
    let borderTopBorder = 'transparent';

    if (!this.hideBottomBorder) {
      if (this.variant === 'border') {
        borderBottomColor = this.borderColor; // Use borderColor if variant is 'border'
      }
    }

    if (!this.hideTopBorder) {
      if (this.variant === 'border') {
        borderTopBorder = this.borderColor; // Use borderColor if variant is 'border'
      }
    }

    return {
      'background-color': this.backgroundColor,
      'border-color':
        this.variant === 'border' ? this.borderColor : 'transparent',
      'border-bottom-color': borderBottomColor, // Use the calculated value
      'padding-top': this.pt,
      'padding-right': this.pr,
      'padding-bottom': this.pb,
      'padding-left': this.pl,
      'border-top-left-radius.px': this.topLeftRadius,
      'border-top-right-radius.px': this.topRightRadius,
      'border-bottom-left-radius.px': this.bottomLeftRadius,
      'border-bottom-right-radius.px': this.bottomRightRadius,
      'min-height.px': this.minHeight,
      'border-top-color': borderTopBorder,
      'min-width.px': this.minWidth,
      ...this.styleProp, // Merges additional styles from styleProp
    };
  }
}
